import {
  createFrontendModule,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import React from 'react';

// Admin-only page; the custom AppShell shows its nav entry to admins only.
const platformRouteRef = createRouteRef();

const platformPage = PageBlueprint.make({
  name: 'platform',
  params: {
    path: '/platform',
    routeRef: platformRouteRef,
    loader: () =>
      import('./PlatformPage').then(m => React.createElement(m.PlatformPage)),
  },
});

export const platformModule = createFrontendModule({
  pluginId: 'app',
  extensions: [platformPage],
});
